import { Component, Input, OnInit } from "@angular/core";
import { AlertController, ModalController} from "@ionic/angular";
import { Store } from "@ngrx/store";
import { AppModeService } from "src/app/angular-wallet-base/services/app-mode.service";
import { getSideMenuStatus } from "src/app/angular-wallet-base/store/appSettings";
import { AppState } from "src/app/angular-wallet-base/store/appState";
import { getBankAccountList } from "src/app/angular-wallet-base/store/bankAccounts";
import { SubscriptionListenerComponent } from "src/app/angular-wallet-base/SubscriptionListenerComponent";
import { DepositFundsModalComponent } from "../deposit-funds-modal/deposit-withdraw-funds-modal";
import { take } from 'rxjs/operators';
import { TranslateService } from "@ngx-translate/core";



@Component({
    selector: "app-success-deposit-page",
    templateUrl: "./success-deposit-modal.html",
    styleUrls: ["./success-deposit-modal.scss"],
})
export class SuccessDepositModalComponent extends SubscriptionListenerComponent implements OnInit {
    public isDesktopMode = false;
    @Input() totalToShow;
    @Input() title;
    @Input() subtitle;
    @Input() message;
    @Input() isSuccess;
    @Input() action;
    bankAccounts = [];
constructor(
        protected store: Store<AppState>,
        private translate: TranslateService,
        public alertController: AlertController,
        public appMode: AppModeService,
        public modalController: ModalController,
    ) {
        super(store);
        this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);

    }

    async ngOnInit() {
        this.getBankAccounts();

    }
    getBankAccounts(){
        this.subscriptions.add(this.store.select(getBankAccountList).subscribe((bankAccount) => {
          this.bankAccounts = bankAccount.data;
        }));
      }
    closeModal() {
        this.modalController.dismiss();
      }
      async openDepositWithdrawModal(){
            this.modalController.dismiss();
            let cssClass = '';
            const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
            cssClass += (this.isDesktopMode) ? 'deposit-modal-desktop' : 'deposit-modal';
            cssClass += (!sideMenuHidden && this.isDesktopMode) ? ' with-side-menu' : '';
            const modal = await this.modalController.create({
              component: DepositFundsModalComponent,
              cssClass,
              componentProps:{
                action:this.action,
                bankAccounts:this.bankAccounts 
              },
              initialBreakpoint: (this.isDesktopMode) ? undefined : 0.6,
              breakpoints: (this.isDesktopMode) ? undefined : [0, 0.4, 0.6, 1],
              id: 'depositFundsModal'
            });
            await modal.present();
        }
        
}
